// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"e7297e1b","308":"8416f0cb","453":"3086abbb","477":"dc34f4ae","506":"3d4ec865","530":"8aa8adb4","580":"e45afe1d","644":"39ffc4da","706":"9364cdb3","885":"26c67391"}[chunkId] + ".chunk.js";
};